var map = {
	"./1piechart.png": 136,
	"./2piechart.png": 137,
	"./3piechart.png": 138,
	"./Asset 1.png": 102,
	"./Asset 10.png": 103,
	"./Asset 11.png": 104,
	"./Asset 12.png": 105,
	"./Asset 13.png": 106,
	"./Asset 14.png": 107,
	"./Asset 15.png": 108,
	"./Asset 16.png": 109,
	"./Asset 17.png": 110,
	"./Asset 18.png": 111,
	"./Asset 19.png": 112,
	"./Asset 2.png": 113,
	"./Asset 20.png": 114,
	"./Asset 21.png": 115,
	"./Asset 22.png": 116,
	"./Asset 23.png": 117,
	"./Asset 24.png": 118,
	"./Asset 25.png": 119,
	"./Asset 26.png": 120,
	"./Asset 27.png": 121,
	"./Asset 28.png": 122,
	"./Asset 29.png": 123,
	"./Asset 3.png": 124,
	"./Asset 30.png": 125,
	"./Asset 4.png": 126,
	"./Asset 5.png": 127,
	"./Asset 8.png": 128,
	"./Asset 9.png": 129,
	"./p1.png": 483,
	"./p2.png": 484,
	"./p3.png": 485,
	"./p4.png": 486,
	"./p5.png": 487,
	"./p6.png": 488,
	"./p7.png": 489,
	"./p8.png": 490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 482;